import {getField, updateField} from 'vuex-map-fields';
import find from 'lodash/find';
import isUndefined from 'lodash/isUndefined';
import actions from '../actions';

export const locatorModule = {
    namespaced: true,
    state: {
        locatorType: null,
        data: {
            list: [],
            processing: false,
        },
        filter: {
            search: null,
            lat: null,
            lng: null,
            types: [],
            products: [],
            radius: 10,
        },
        products: {
            list: []
        },
        map: {
            center: {
                lat: 50.080388, lng: 14.410427
            },
            zoom: 12,
        }
    },
    getters: {
        mapCenter: (state) => state.map.center,
        mapZoom: (state) => state.map.zoom,
        products: (state) => state.products.list,
        locatorType: (state) => state.locatorType,
        contacts: (state) => state.data.list,
        contactById: (state, getters) => (contactId) => {
            const contact = find(getters.contacts, {token: contactId});
            return isUndefined(contact) ? null : contact;
        },
        markers(state, getters) {
            return getters.contacts.map((contact) => ({
                id: contact.id,
                token: contact.token,
                position: {
                    lat: contact.company.coordinates.location ? parseFloat(contact.company.coordinates.location.lat) : null,
                    lng: contact.company.coordinates.location ? parseFloat(contact.company.coordinates.location.lon) : null
                }
            }))
        },
        filter: (state) => state.filter,
        search: (state) => state.filter.search,
        getField,
    },
    actions,
    mutations: {
        fetchContactProcess: (state, status) => state.data.processing = status,
        setContacts: (state, contacts) => state.data.list = contacts,
        setProducts(state, products) {
            products.unshift({id: 'all', name: 'vše'});
            state.products.list = products;
        },
        setTypes: (state, types) => state.filter.types = types,
        setProductsType: (state, products) => state.filter.products = products,
        setLocatorType: (state, type) => state.locatorType = type,
        setCoords(state, {lat, lng}) {
            state.filter.lat = lat;
            state.filter.lng = lng;
        },
        setSearch: (state, q) => state.filter.search = q,
        setMapCenter: (state, position) => state.map.center = position,
        setMapZoom: (state, zoom) => state.map.zoom = zoom,
        updateField
    },
}



// WEBPACK FOOTER //
// ./src/components/locator/store/index.js